import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UserListLayer from "../components/UserListLayer";

const UserListPage = () => {
    return (
        <MasterLayout>
            <UserListLayer />
        </MasterLayout>
    );
};

export default UserListPage;
